import type { FaireProductEntity } from "../../entity_types/product";

export const p_dfmwmb3xze: FaireProductEntity = {
  token: "p_dfmwmb3xze",
  type: "product",
  name: "ET6930   STRIPED WAFFLE FABRIC LONG SLEEVE TOP",
  brandToken: "b_4bdmvim3s7",
  brandName: "MIOU MUSE",
  imageUrl:
    "https://cdn.faire.com/fastly/bef0ac9e6e771aac0ba9e2c174e0918ee60ecbca59225c3d4b7e6bdb970058c4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f50252db84bb5c5e7163f392a78436f20ac10be2b36ceb1240ecd9502a3fdcf5.jpeg",
    "https://cdn.faire.com/fastly/6997377fbe6e238e77b1544822c22b30e776bfdac5ab5bba7ab92a834ed85031.jpeg",
    "https://cdn.faire.com/fastly/563d933c5c9408c7b130839c2c29504460d9a9928fca0bc809dd9c4b25933482.jpeg",
    "https://cdn.faire.com/fastly/bb3f7d664b7186b68e59d34593a128903fe2c9a3154c66f3934f19a2cf1aeb5c.jpeg",
    "https://cdn.faire.com/fastly/3a2efed82c03166914d55d06375d1829f15af38b4fddc377a39d34d9012de487.jpeg",
    "https://cdn.faire.com/fastly/3d4fc76ac2ba78853ba2069c0c414cbccea0d3237fb7790719719362b0aaee95.jpeg",
    "https://cdn.faire.com/fastly/200a518d56ac95176592efba392f1cce931dd229ac2a69b9de1d6bd717ccc584.jpeg",
    "https://cdn.faire.com/fastly/10bf235bd0bad79b587e2f8b38eb83cf8334aec4a2e383ae5745ec8b1bf03709.jpeg",
    "https://cdn.faire.com/fastly/37e61f59f82e738da63c6caa9b99350ded8b1c3c6a168b4323378cda0d058ef3.jpeg",
    "https://cdn.faire.com/fastly/c5d2ab513d1a92bc3412faeddb1406395350aba6cfb509f8dda7be8df764a2b0.jpeg",
    "https://cdn.faire.com/fastly/196e67db8f67c6e88d1a425d5539d1f6f123be32e68d88851bf6f50e1ff47270.jpeg",
    "https://cdn.faire.com/fastly/ebf7a8cc3fed2baa1bb7064faf1817c4d20093e3fdd8b1eb93fd8c22cde47334.jpeg",
    "https://cdn.faire.com/fastly/cd07373bc618a5e3da177ed0e3ea90504ada57a14cb64bdf33515781fb657c8c.jpeg",
    "https://cdn.faire.com/fastly/6bbb9f1a714be9c1c063cf69ced055fa4e4303c93113553a18a4569f5775f53d.jpeg",
    "https://cdn.faire.com/fastly/d9a3106a7f425ce78b6ed6bccd29d6b348c72f6b4fa78fced8c7856526e17fe2.jpeg",
    "https://cdn.faire.com/fastly/4f617cae5b5e3a48a41571ff71a66b117534a00d6dd5d301eaadedb437918ea4.jpeg",
    "https://cdn.faire.com/fastly/d9d724a2cd5ecb6dff6e0063de6271e52622b1efb231718c5c38a56ad5cead29.jpeg",
    "https://cdn.faire.com/fastly/e10ad61c6462a01c6aa11bebbcb65d7d4e799e2713305cd63ec48c3eea50a78e.jpeg",
    "https://cdn.faire.com/fastly/b61dd4c1ef5f88b1f1d91ce5397647deb765f375633eb8cb8b959378b5eeac66.jpeg",
  ],
  priceDollars: 135,
  description:
    "Design & Pattern\n- Pattern: Classic horizontal stripes alternating in brown and white tones.\n- Texture: Textured waffle-knit weave providing dimensional depth and a casual look.\n- Neckline: Simple crew neckline with clean-finish stitched detailing along the hem.\n\nFabric & Fit\n- Fit: Relaxed, comfortable standard fit with an easy pullover design.\n- Fabric Feature: Soft, breathable waffle fabric blend of 65% Polyester 35% Cotton for durability and comfort.\n- Silhouette Feature: Long-sleeve casual top with dropped shoulders and a slightly cropped hemline.\n\nBest Occasions\n- Casual Outings: Perfect for daily errands, coffee runs, or casual weekend hangouts.\n- Everyday Lounging: Comfortable choice for staying cozy at home or light outdoor activities.\n\nMix & Match\n- Streetwear Chic: Pair with high-waisted denim jeans, a baseball cap, and sneakers.\n- Cozy Layering: Style under an oversized jacket or shacket with joggers for a relaxed vibe.",
  tags: [],
  msrpDollars: 270,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:55.843Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
